import { useMutation } from "@tanstack/react-query";
import { APIErrorResponse } from "src/types/generic";
import apiFastifyClient from "../apiFastifyCloud";

interface IParams {
  type?: "employee" | "service";
  page?: number;
  limit?: number;
  cityIds?: string[];
  locationIds?: string[];
  ratings?: number[];
  startDate?: string;
  endDate?: string;
  clientId?: string;
  serviceTypes?: string[]
}

export const useFetchCustomersFeedbackMutation = () =>
  useMutation<any, APIErrorResponse, IParams>({
    mutationFn: async (data) => {
      return apiFastifyClient.post(`/v1/feedback/list`, data);
    },
  });

export const useFetchFeedbackAvgRatingMutation = () =>
  useMutation<any, APIErrorResponse, IParams>({
    mutationFn: async (data) => {
      return apiFastifyClient.post(`/v1/feedback/average-rating`, data);
    },
  });
